import { formatCurrency } from '@quickstock/shared';

/**
 * Money is formatted by the same module the till prints receipts with, so a
 * figure here and a figure on paper can never disagree about rounding or the
 * placement of a minus sign.
 */
export { formatCurrency };

export function formatCount(value: number | string): string {
  return Number(value).toLocaleString('en-GB');
}

/** Times are rendered in the store's timezone, not the reader's. */
export function formatDateTime(iso: string, timeZone: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    timeZone,
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDate(iso: string, timeZone: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    timeZone,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/** A YYYY-MM-DD from the database, which carries no timezone. */
export function formatPlainDate(value: string): string {
  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) return value;

  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString('en-GB', {
    timeZone: 'UTC',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatPercent(value: string | null): string {
  return value === null ? '—' : `${value}%`;
}
